import { type FunctionComponent } from 'react';
import { Rating } from '../../../product-components/rating/rating.component';

export type ReviewStarRatingProps = {
	reviewCount: number;
	ratingValue: number;
	productUrl: string;
};

export const ReviewStarRating: FunctionComponent<ReviewStarRatingProps> = ({ reviewCount, ratingValue, productUrl }) => {
	return (
		<div className={'flex flex-wrap min-h1'}>
			<Rating ratingValue={ratingValue} url={`${productUrl}#reviews`} reviewCount={reviewCount} abbreviatedReviewCount={true} />
		</div>
	);
};
